function AppBeside(p){
    return(
        <section className="beside">{p.children}</section>
    );
}

export default AppBeside;